export default {
  BOOK_BATCH_CANCEL_TIP: 'Cancel the "time conflict, booked" desks',
  BOOK_CANCEL_RESERVED_DESK: 'Cancel All',
  BOOK_GOTCHA: 'Confirm',
  MAP_MORE_DESK: 'Desk can be booked up to {reserveCount} seat  at one time',
  MAP_MORE_DESKS: 'Desk can be booked up to {reserveCount} seats  at one time',
  UNASSIGNED_STORAGE_LOCKER: 'Unassigned storage locker'
}
